module.exports = __webpack_public_path__ + "img/flow.6fe16643.png";